import { render, staticRenderFns } from "./ImsDeletedOfferings.vue?vue&type=template&id=9588b740&"
import script from "./ImsDeletedOfferings.vue?vue&type=script&lang=js&"
export * from "./ImsDeletedOfferings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports